import React, { useState } from "react";
import PropTypes from "prop-types";
import List from "@8x8/oxygen-list";
import {
  DownloadCsv,
  AddRowsFromFile,
  UpdateRowsFromFile,
} from "@/react/components/table/components/file-actions";
import ButtonDropdown from "@/react/components/ButtonDropdown";
import {
  StyledArrowDownIcon,
  StyledCSVIcon,
} from "@/react/components/styled/StyledIcons";
import {
  FileActionsContainer,
  FullWidthListItem,
} from "@/react/components/table/components/file-actions/styled";
import { FlexButton } from "@/react/components/table/styled";

const TriggerButton = () => (
  <FlexButton variant="tertiary">
    <StyledCSVIcon size={18} />
    <span>File Actions</span>
    <StyledArrowDownIcon size={18} />
  </FlexButton>
);

const FileActions = (props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  return (
    <FileActionsContainer>
      <ButtonDropdown
        target={<TriggerButton />}
        isOpen={isDropdownOpen}
        setIsOpen={setIsDropdownOpen}
        dropdownKey={`file-actions-${props.title}`}
      >
        <List isGroup>
          {props.fileActions.enableAdd && props.addRows && (
            <FullWidthListItem>
              <AddRowsFromFile
                columns={props.allColumns}
                rows={props.prePaginationRowModel.rows}
                addRows={props.addRows}
                schema={props.schema}
                processInput={props?.processFileUpload}
              />
            </FullWidthListItem>
          )}
          {props.fileActions.enableUpdate && props.bulkUpdateRows && (
            <FullWidthListItem>
              <UpdateRowsFromFile
                columns={props.allColumns}
                rows={props.prePaginationRowModel.rows}
                bulkUpdateRows={props.bulkUpdateRows}
                schema={props.schema}
                identifierColumnId={props.fileActions.identifierColumnId}
                processInput={props?.processFileUpload}
              />
            </FullWidthListItem>
          )}
        </List>
        {props.fileActions.enableDownload && (
          <List isGroup>
            <FullWidthListItem>
              <DownloadCsv
                columns={props.allColumns}
                rows={
                  props.selectedRowModel.rows.length > 0
                    ? props.selectedRowModel.rows
                    : props.prePaginationRowModel.rows
                }
                title={props.title}
              />
            </FullWidthListItem>
          </List>
        )}
      </ButtonDropdown>
    </FileActionsContainer>
  );
};

export const fileActionsProps = {
  enableAdd: PropTypes.bool,
  enableUpdate: PropTypes.bool,
  enableDelete: PropTypes.bool,
  enableDownload: PropTypes.bool,
  identifierColumnId: PropTypes.string.isRequired,
  processFileUpload: PropTypes.func,
};

FileActions.propTypes = {
  addRows: PropTypes.func,
  bulkUpdateRows: PropTypes.func,
  allColumns: PropTypes.array,
  title: PropTypes.any,
  schema: PropTypes.any,
  selectedRowModel: PropTypes.any,
  prePaginationRowModel: PropTypes.any,
  fileActions: PropTypes.shape(fileActionsProps).isRequired,
};

export default FileActions;
